import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reports" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Reports")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "col-sm-6 text-right"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1)
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-day" }, null, -1)

import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import moment from 'moment-timezone';
import _ from 'lodash';

import ReportsList from '@/components/dataentry/DEList.vue';
import ReportsSearchByMonth from '@/components/dataentry/SearchByMonth.vue';
import ReportsSearchByString from '@/components/dataentry/SearchByString.vue';
import ReportsSearchByStatus from '@/components/dataentry/SearchByStatus.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

// State
const reportsState = computed(() => store.state.reports);

// Getters
const isDataentry = computed(() => store.getters['auth/isDataentry']);

// Actions
const setMonth = (month: string): Promise<any> => store.dispatch('reports/setMonth', month);
const setDataentrystatus = (status: string): Promise<any> => store.dispatch('reports/setDataentrystatus', status);
const setSearch = (search: string): Promise<any> => store.dispatch('reports/setSearch', search);
const getReports = (payload: { withbooking: boolean }): Promise<any> => store.dispatch('reports/getReports', payload);
const resetCurrentPage = (): Promise<any> => store.dispatch('reports/resetCurrentPage');
const setCurrentPage = (page: number): Promise<any> => store.dispatch('reports/setCurrentPage', page);

// Methods
const prepareQuery = () => {
  let query = { month: '', search: '', dataentrystatus: '' };
  if (!reportsState.value.month && !reportsState.value.search && !reportsState.value.dataentrystatus){
    const page = reportsState.value.page ? Number(reportsState.value.page) : 1;
    setCurrentPage(page);
    setMonth(moment().format("YYYY-MM"));
    query["month"] = moment().format("YYYY-MM");
  } else {
    if (reportsState.value.month)
      query["month"] = reportsState.value.month;
    if (reportsState.value.search)
      query["search"] = reportsState.value.search;
    if (reportsState.value.dataentrystatus)
      query["dataentrystatus"] = reportsState.value.dataentrystatus;
  }  
  return query;
};

const resetSearch = () => {
  if (route.query.month != moment().format("YYYY-MM")) {
    router.push({
      path: "dereports",
      query: { month: moment().format("YYYY-MM") },
    });
    resetCurrentPage();
  }
};

// Watchers and Lifecycle Hooks
onMounted(async () => {
  const query = route.query;
  if (typeof query.month === "string" && query.month.length) {
    const page = query.page ? Number(query.page) : 1;
   setCurrentPage(page);
   setMonth(query.month)
   .then(() => getReports({ withbooking: true }));
  } else if (typeof query.search === "string" && query.search.length) {
   setSearch(query.search)
   .then(() => getReports({ withbooking: true }));
  } else if (typeof query.dataentrystatus === "string" && query.dataentrystatus.length) {
   setDataentrystatus(query.dataentrystatus)
   .then(() => getReports({ withbooking: true }));
  } else {
    const queryToPush = prepareQuery();
    router.push({ path: "dereports", query: queryToPush });
  }
});

watch(() => route.query.month, async (val, oldVal) => {
  if (val) {
   setMonth(val as string)
   .then(() => getReports({ withbooking: true }));
  }
});

watch(() => route.query.search, async (val, oldVal) => {
  if (val) {
   setSearch(val as string)
   .then(() => getReports({ withbooking: true }));
  }
});

watch(() => route.query.dataentrystatus, async (val, oldVal) => {
  if (val) {
   setDataentrystatus(val as string);
   getReports({ withbooking: true });
  } else {
   setDataentrystatus('')
   .then(() => getReports({ withbooking: true }));
  }
});

watch(() => route.query.page, async (val, oldVal) => {
  if (val) {
   setCurrentPage(Number(val))
   .then(() => getReports({ withbooking: true }));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (isDataentry.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "btn btn-lg btn-primary",
                to: "/dereports/new"
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" New Report ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ReportsSearchByMonth, { class: "col-sm-2" }),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-outline-primary col-sm-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (resetSearch()))
      }, [
        _hoisted_7,
        _createTextVNode(" This month ")
      ]),
      _createVNode(ReportsSearchByStatus, { class: "col-sm-3" }),
      _createVNode(ReportsSearchByString, {
        class: "col-sm-6",
        placeholder: "Search all reports"
      })
    ]),
    _createVNode(ReportsList)
  ]))
}
}

})